<div
  *transloco="let t; read: 'predictive-chart-widgetette'"
  class="predictive-chart-widgetette__container"
>
  <div class="predictive-chart-widgetette__header">
    <span class="predictive-chart-widgetette__title">{{ t('quad-chart') }}</span>

    <span class="predictive-chart-widgetette__breakdown">{{ breakdown?.name }}</span>
  </div>

  <div #chart class="predictive-chart-widgetette__chart"></div>
</div>

@if (isPopoutVisible) {
  <app-lex-xi-popout
    [isVisible]="isPopoutVisible"
    [element]="pointElement"
    [internalPadding]="0"
    (close)="onClosePopout()"
  >
    <ng-template appXIPopoutContent>
      @if (isPopoutVisible) {
        <app-point-popout
          [isDashboardLocked]="isDashboardLocked"
          (smartSummary)="onSmartSummary()"
        ></app-point-popout>
      }
    </ng-template>
  </app-lex-xi-popout>
}
